import editSchema from "../../getters/editSchema";

const bpmn = editSchema;
export default bpmn;
